module.exports = __webpack_public_path__ + "img/logo.cca38ab6.png";